export function IgnoreUrlDelete(req) {
    if (
        !(req.url.includes('ticket/details'))
    ) {
        return true;
    } else {
        return false;
    }
}
export function IgnoreUrlPut(req) {
    if (
        !(req.url.includes('ticket/details'))
        && !(req.url.includes('message/all'))
        && !(req.url.includes('ticket/all'))
        && !(req.url.includes('user/search'))
        && !(req.url.includes('subCategory/all'))
        && !(req.url.includes('common/specific'))
        // && !(req.url.includes('user/specialUser') && !req.url.includes('extraInfo'))
        && !(req.url.includes('post/notFreePostsSearch'))
        && !(req.url.includes('post/outOfDatePostsSearch'))
        && !(req.url.includes('post/freePostsSearch'))
        && !(req.url.includes('post/linkedMagazine/all'))
        && !(req.url.includes('post/specific'))
        && !(req.url.includes('post/comment'))
        && !(req.url.includes('post/score'))
        && !(req.url.includes('all'))
        && !(req.url.includes('user/specialUser/search'))
        && !(req.url.includes('contract/specificPost'))
        && !(req.url.includes('contract/payments/specificContract'))
    ) {


        return true;
    } else {

        return false;
    }
}
export function IgnoreUrlPost(req) {
    if (
        !(req.url.includes('ticket/details'))
        && !(req.url.includes('uploadImage'))
        && !(req.url.includes('user/specialUser'))
    ) {
        return true;
    } else {
        return false;
    }
}
